import { render, staticRenderFns } from "./ModalCadastroCurso.vue?vue&type=template&id=2713bd27"
import script from "./ModalCadastroCurso.vue?vue&type=script&lang=js"
export * from "./ModalCadastroCurso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports